import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/lottie-animation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpotlightCard"] */ "/vercel/path0/src/components/ui/spotlight-card.tsx");
